export class ValidationError {
    constructor() {
        this.errors = [];
    }
    add(field, message) {
        let errorIndex = this.errors.findIndex(p => p.fieldName === field);
        if (errorIndex > -1) {
            this.errors[errorIndex].messages.push(message);
        }
        else {
            this.errors.push({
                fieldName: field,
                messages: [message]
            });
        }
    }
    purge() {
        this.errors = [];
    }
    hasError(field) {
        return this.errors.filter(p => p.fieldName === field && p.messages.length > 0).length > 0;
    }
    hasErrors() {
        return this.errors.filter(p => p.messages.length > 0).length > 0;
    }
    getMessage(field) {
        const error = this.errors.filter(p => p.fieldName === field);
        if (error.length > 0) {
            return error[0].messages;
        }
        return [];
    }
}
export class FormValidation {
    static validate(constraints, sources) {
        const result = new ValidationError();
        const sourceEntries = Object.entries(sources);
        constraints.forEach(constraint => {
            const sourceEntryIndex = sourceEntries.findIndex(p => p[0] === constraint.field);
            if (sourceEntryIndex > -1) {
                const validateTarget = sourceEntries[sourceEntryIndex];
                for (let idx = 0; idx < constraint.validate.length; idx++) {
                    const valid = constraint.validate[idx];
                    let validateResult = false;
                    if (valid[3]) {
                        validateResult = valid[0](validateTarget[1] ?? '', valid[3]);
                    }
                    else {
                        validateResult = valid[0](validateTarget[1] ?? '');
                    }
                    console.debug(`${valid[0].name}[${validateTarget[0]}] => ${validateResult} (value: ${validateTarget[1]})`);
                    if (validateResult !== valid[2]) {
                        result.add(constraint.field, valid[1]);
                        break;
                    }
                }
            }
        });
        return result;
    }
}
